import { Component } from '@angular/core';
import { GeneralService } from '../general.service';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-incomplete-transactions',
  templateUrl: './incomplete-transactions.component.html',
  styleUrls: [
    '../dasboard/dasboard.component.css',
    './incomplete-transactions.component.css',
  ],
})
export class IncompleteTransactionsComponent {
  constructor(private s: GeneralService) {}
  dataSource: any;
  displayedColumns: string[] = [
    'companyEmail',
    // 'netPrice',
    'grossPremium',
    // 'percentage',
    'numberOfDay',
    'updated_at',
    '_id',
  ];
  arr: any[] = [];
  ngOnInit(): void {
    this.s
      .getAllTrxnsByCmpny(JSON.parse(localStorage.getItem('user')!).email)
      .subscribe((r: any) => {
        this.s.loader = false;
        for (let index = 0; index < r.length; index++) {
          if (!(r[index]['Policy_Detail_Info']['transactionStatus'] == 'paid')) {
            this.arr.push(r[index]['Policy_Detail_Info']);
          }
        }
        this.dataSource = new MatTableDataSource(this.arr.reverse());
      });
    throw new Error('Method not implemented.');
  }
}
